module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_r1_dark.78ed2da5.svg";